/* global axios */

import ApiClient from './ApiClient';

class VaultSageAPI extends ApiClient {
  constructor() {
    super('integrations/vaultsage', { accountScoped: true });
  }

  connect(payload) {
    return axios.post(this.url, payload);
  }

  updateConnection(payload) {
    return axios.patch(this.url, payload);
  }

  validate(payload) {
    return axios.post(`${this.url}/validate`, payload);
  }

  listFiles(params = {}) {
    return axios.get(`${this.url}/files`, { params });
  }

  resolveShareLinks(links) {
    return axios.post(`${this.url}/resolve_share_links`, { links });
  }

  disconnect() {
    return axios.delete(this.url);
  }

  replyDraft(conversationId, botId = null) {
    return axios.post(`${this.url}/reply_draft`, {
      conversation_id: conversationId,
      bot_id: botId,
    });
  }

  ask(conversationId, message, botId = null) {
    return axios.post(`${this.url}/ask`, {
      conversation_id: conversationId,
      message,
      bot_id: botId,
    });
  }
}

export default new VaultSageAPI();
